class BlogPromoBanner {
  constructor() {
    this.banner = document.getElementById('blog-promo-banner');
    if (!this.banner) return;

    this.closeButton = this.banner.querySelector('.blog-promo-banner__close');
    this.hasShown = false;
    this.timeoutId = null;
    this.scrollThreshold = window.innerHeight * 1.5;
    this.delayTime = 7000;
    this.storageKey = 'blogPromoBannerDismissedAt';
    this.dismissDurationMs = 10 * 60 * 1000; // 10 minutes

    this.init();
  }

  init() {
    if (!this.shouldShowBanner()) {
      return;
    }

    this.setupCloseButton();
    this.setupTriggers();
  }

  shouldShowBanner() {
    const path = window.location.pathname;
    if (!(path.startsWith('/blogs/pl/') || path.startsWith('/en-eu/blogs/pl/'))) {
      return false;
    }

    const dismissedAt = window.localStorage.getItem(this.storageKey);
    if (dismissedAt) {
      const dismissedTime = Number(dismissedAt);
      const now = Date.now();
      if (!Number.isNaN(dismissedTime) && now - dismissedTime < this.dismissDurationMs) {
        return false;
      }
    }

    // Avoid showing on extremely small viewports where it could block reading.
    const tooSmallViewport = window.innerWidth < 320 || window.innerHeight < 500;
    return !tooSmallViewport;
  }

  setupCloseButton() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => {
        this.hide();
      });
    }
  }

  setupTriggers() {
    this.setupTimeout();
    this.setupScrollListener();
  }

  setupTimeout() {
    this.timeoutId = setTimeout(() => {
      this.show();
    }, this.delayTime);
  }

  setupScrollListener() {
    let scrollListenerActive = true;

    const handleScroll = () => {
      if (!scrollListenerActive || this.hasShown) {
        return;
      }

      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollPosition >= this.scrollThreshold) {
        this.show();
        scrollListenerActive = false;
        if (this.timeoutId) {
          clearTimeout(this.timeoutId);
        }
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
  }

  show() {
    if (this.hasShown) return;

    this.banner.removeAttribute('hidden');
    this.hasShown = true;
  }

  hide() {
    this.banner.setAttribute('hidden', '');
    window.localStorage.setItem(this.storageKey, String(Date.now()));
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BlogPromoBanner();
  });
} else {
  new BlogPromoBanner();
}
